import AboutAPI from '../api/rest/directus-cms/about';
import { aboutPageData } from '../stores/stores';
export function fetchAboutData(lang) {
    if (lang == null)
        lang = String(process.env.LOCALE);
    AboutAPI.getInstance()
        .getAboutCollection(lang)
        .then(response => {
        aboutPageData.set(response);
    })
        .catch(error => {
        console.log(error);
    });
}
